let today = new Date();
let months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

export default {
    state: {
        url: '/api/hms/locations/billings',
        billings: [],
        billing: [],
        billing_id: null,
        errors: {},
        form: {
            facility_id: '',
            date: today.getFullYear() + '-' + months[today.getMonth()] + '-01',
            notes: ''
        },
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true, tdClass: ''},
                {key: 'facility', label: 'Facility', tdClass: 'text-muted'},
                {key: 'date', label: 'Period', sortable: true, tdClass: 'text-muted'},
                {key: 'rate', label: 'Rate', sortable: true, tdClass: 'text-muted text-right'},
                {key: 'total', label: 'Total', sortable: true, tdClass: 'text-muted text-right'},
                {key: 'created_at', label: 'Created At', sortable: true, tdClass: 'text-muted text-right'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        }
    },

    getters: {
        getBilling: state => state.billing,

        getBillingTableFields: state => state.table.fields,

        getBillingsMeta: state => state.meta,

        getBillingErrors: state => state.errors,

        getBillingForm: state => state.form,
    },

    mutations: {
        resetBillingsMeta: state => {
            state.meta = {
                current_page: 1,
                per_page: 10,
                total: 0,
                from: '',
                to: '',
                sort: 'desc',
                order_by: 'Choose',
                sort_by: 'created_at',
                sort_desc: true,
                search: '',
                page_sizes: [10, 25, 50, 100],
            };
        },

        setBillings: (state, payload) => {
            state.billings = payload;
        },

        setBilling: (state, payload) => {
            state.billing_id = payload.billing_id;
            state.billing = payload;
        },

        setBillingsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setBillingErrors: (state, payload) => {
            state.errors = payload;
        },

        setBillingForm: state => {
            state.form = {
                facility_id: '',
                date: today.getFullYear() + '-' + months[today.getMonth()] + '-01',
                notes: '',
            };

            state.errors = {};
        },

    },

    actions: {
        fetchBillings: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setBillings', response.data);

                        commit('setBillingsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setBillingErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchBilling: ({state, commit}, billing_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + billing_id)
                    .then(response => {
                        commit('setBilling', response.data);

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitBilling: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setBillingErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        deleteBilling: ({state, commit}, billing_id) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + billing_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
